export class Border {
    LeftBorder: any;
    RightBorder: any;
}